import * as actionTypes from './actionTypes';
//import axios from 'axios';
import axiosDurex from '../../axios-setup';

export const getResultsByDay = (day) => {
	return dispatch => {
		dispatch(startResultsGet());
		var resultObj=[];
		axiosDurex.get('/resultsByDay/'+day+'.json')
		.then( res => {
			//console.log(res.data);
			axiosDurex.get('/usersPublic.json')
			.then( res2 => {
				//dispatch(setResultsByDay(res.data,res2.data));

				for (var m in res.data) {
					var subData=[];
					for (var o in res.data[m]) {

						if (res2.data[res.data[m][o]['uid']]!==undefined) {
							var subSubData = {
								...res.data[m][o],
								ime: res2.data[res.data[m][o]['uid']]['ime'],
								avatar: res2.data[res.data[m][o]['uid']]['avatar']
							}
							subData.push(subSubData);
						}
					}
					resultObj[m] = subData;
				}
				//console.log(resultObj);
				dispatch(setResultsByDay(resultObj));
			})
			.catch (err => {
				console.log('error getting user public data for day: '+err);
			})
		})
		.catch( (err) => {
			console.log('error getting result by day: '+err);
		});
	}
}

export const startResultsGet = () => {
	return {
		type: actionTypes.GET_RESULTS_BY_DAY,
	}
}


export const setResultsByDay = (results) => {
	return {
		type: actionTypes.SET_RESULTS_BY_DAY,
		results: results,
	}
}


export const getResultsByWeek = (day) => {
	return dispatch => {
		dispatch(startResultsGetWeek());
		var resultObj=[];

		axiosDurex.get('/resultsByWeek/'+day+'.json')
		.then( res => {
			//console.log(res.data);
			axiosDurex.get('/usersPublic.json')
			.then( res2 => {
				//dispatch(setResultsByDay(res.data,res2.data));
				
				for (var m in res.data) {
					var subData=[];
					for (var o in res.data[m]) {

						if (res2.data[res.data[m][o]['uid']]!==undefined) {
							var subSubData = {
								...res.data[m][o],
								ime: res2.data[res.data[m][o]['uid']]['ime'],
								avatar: res2.data[res.data[m][o]['uid']]['avatar']
							}
							subData.push(subSubData);
						}
					}
					resultObj[m] = subData;
				}
				//console.log(resultObj);
				dispatch(setResultsByWeek(resultObj));
			})
			.catch (err => {
				console.log('error getting user public data for week: '+err);
			})
		})
		.catch( (err) => {
			console.log('error getting result by week: '+err);
		});
	}
}


export const startResultsGetWeek = () => {
	return {
		type: actionTypes.GET_RESULTS_BY_WEEK,
	}
}


export const setResultsByWeek = (results) => {
	return {
		type: actionTypes.SET_RESULTS_BY_WEEK,
		weekResults: results,
	}
}

export const getDailyWinners = () => {
	return dispatch => {
		axiosDurex.get('/dailyWinners.json')
		.then( res => {
			if (res.data===null) {
				dispatch(setDailyWinners(false));
			} else {
				dispatch(setDailyWinners(res.data));
			}
			
		})
		.catch( (err) => {
			console.log('error getting daily winners: '+err);
		});
	}
}

export const setDailyWinners = (data) => {
	return {
		type: actionTypes.GET_WINNERS_BY_DAY,
		winners: data
	}
}

export const getWeeklyWinners = () => {
	return dispatch => {
		axiosDurex.get('/weeklyWinners.json')
		.then( res => {
			if (res.data===null) {
				dispatch(setWeeklyWinners(false));
			} else {
				dispatch(setWeeklyWinners(res.data));
			}
			
		})
		.catch( (err) => {
			console.log('error getting weekly winners: '+err);
		});
	}
}

export const setWeeklyWinners = (data) => {
	return {
		type: actionTypes.GET_WINNERS_BY_WEEK,
		winners: data
	}
}





// WEBPACK FOOTER //
// ./src/store/actions/result.js